/**
 * 直播课程模块
 **/

import {
    // COLLECT_COURSE,
    // INIT_COURSE_INFO,
    // LAST_STUDY_SECTION,
    // SWITCH_SECTION
} from "@constants/action-type/course-action-type";
import {
    LIVE_ONLINE_COURSE_INFO,
    LIVE_ONLINE_SWITCH_SECTION,
    LIVE_ONLINE_COLLECT_COURSE
} from "@constants/action-type/course-live-online-action-type"
// import {changeProgress, collectCourse, courseDetail, courseStudyDate, switchSection} from "@api/courese-detail";
import {collectCourse} from "@api/courese-detail";
import {getLiveCourseDetail, switchSection} from "@api/course-live-online"
import {SUCCESS} from "@constants/code";
import { showSuccessMsg} from "@utils/msg";
import {CHANGE_CURRENT_TIME} from "@constants/mutation-type/course-mutation-type";
import {CHANGE_SIGN_UP} from "@constants/mutation-type/course-live-online-mutation-type";

export default {
    namespaced: true,
    state: {
        isLoadCourse: false,
        courseInfo: {},
        score: 5,
        // 是否支付
        isPaid: false,
        // 是否收藏
        isCollect: false,
        isLoadCollect: false,
        // 是否已经加入购物车
        isInShoppingCart: false,
        // 选中章节
        selectedSection: {},
        // 是否能学习章节
        canStudyCourse: false,
        // 加载章节
        isLoadSection: false,
        currentTime: 0,
        //是否报名
        isSignUp: false,
        playRtmpUrl: "",
        playFlvUrl: "",
        playM3u8Url: "",
        // 下个章节id
        nextLiveSectionId: -1,
        //  课程封面图
        liveCoverUrl: "",
    },
    getters: {},
    mutations: {
        //更改报名状态
        [CHANGE_SIGN_UP](state, {isSignUp}) {
            state.isSignUp = isSignUp
        },

        changeCourseLoad(state, payload) {
            state.isLoadCourse = payload.isLoadCourse;
        },
        initCourseInfo(state, payload) {
            state.courseInfo = payload.courseInfo;
            state.isPaid = payload.isPaid;
            state.isInShoppingCart = payload.isInShoppingCart;
            state.isCollect = payload.isCollect;
            state.score = payload.score;
            state.isSignUp = payload.isSignUp;
            state.playRtmpUrl = payload.playRtmpUrl;
            state.playFlvUrl = payload.playFlvUrl;
            state.playM3u8Url = payload.playM3u8Url;
            state.nextLiveSectionId = payload.nextLiveSectionId;
            state.liveCoverUrl = payload.liveCoverUrl;
        },
        changeSectionLoad(state, payload) {
            state.isLoadSection = payload.isLoadSection;
        },
        changeSection(state, payload) {
            state.selectedSection = payload.selectedSection;
            state.canStudyCourse = payload.canStudyCourse;
        },
        changeCollectLoad(state, payload) {
            state.isLoadCollect = payload.isLoadCollect;
        },
        changeCollect(state, {isCollect}) {
            state.isCollect = isCollect;
        },
        // 修改是否加入购物车
        changeInShoppingCart(state, {isInShoppingCart}) {
            state.isInShoppingCart = isInShoppingCart;
        },
        [CHANGE_CURRENT_TIME](state, {currentTime}) {
            state.currentTime = currentTime;
        }
    },
    actions: {
        [LIVE_ONLINE_COURSE_INFO]({commit}, payload) {
            return new Promise((resolve) => {
                // 加载课程详情
                commit('changeCourseLoad', {isLoadCourse: true});
                getLiveCourseDetail(payload.courseId).then((res) => {
                    // console.log(res)
                    if (res.code === SUCCESS) {
                        commit('initCourseInfo', {
                            courseInfo: res.data.course,
                            isCollect: res.isCollect,
                            isInShoppingCart: res.isInShoppingCart,
                            isPaid: res.isPaid,
                            score: res.score,
                            isSignUp: res.isSignUp,
                            playRtmpUrl: res.data.playRtmpUrl,
                            playFlvUrl: res.data.playFlvUrl,
                            playM3u8Url: res.data.playM3u8Url,
                            nextLiveSectionId: res.data.nextLiveSectionId,
                            liveCoverUrl: res.data.liveCoverUrl,
                        });
                        // 结束加载
                        commit('changeCourseLoad', {isLoadCourse: false});
                    }
                    resolve(res);
                });
            })
        },
        [LIVE_ONLINE_SWITCH_SECTION]({commit}, {sectionId}) {
            // 显示加载中
            commit('changeSectionLoad', {isLoadSection: true});
            // 切换章节
            switchSection(sectionId).then((res) => {
                //todo 判断liveStatus
                if (res.code === SUCCESS) {
                    commit('changeSection', {
                        canStudyCourse: res.canStudyCourse,
                        selectedSection: res.section || {}
                    });
                    commit('changeSectionLoad', {isLoadSection: false});
                }
            })
        },
        [LIVE_ONLINE_COLLECT_COURSE]({commit, state}, {courseId}) {
            commit('changeCollectLoad', {isLoadCollect: true});
            return collectCourse(courseId).then((res) => {
                if (res.code === 0) {
                    showSuccessMsg('收藏成功');
                    commit('changeCollect', {isCollect: !state.isCollect});
                }
                commit('changeCollectLoad', {isLoadCollect: false});
                return res;
            })
        }
    }
}
